import { EventSentToMobileApp } from "../constants/GlobalTypesAndEnumsAndConstants";
import { trackError } from "../utils/analytics/track-error";
import { doesMobileAppFollowTheColorTheme, getPageBackgroundColorForTheme, JungleColorTheme } from "./jungleColorTheme";

// The message that tells the mobile app the page's theme, so it can paint the strip behind the phone's
// status bar (and Android's navigation bar) in the page's color and turn the clock and battery light over
// a dark page (jungle-mobile, HomeScreen.tsx, `color_theme`). The color is a plain hex value: the app
// cannot read CSS variables.
export type MobileAppColorThemeMessage = {
  typeEvent: EventSentToMobileApp.COLOR_THEME;
  colorTheme: JungleColorTheme;
  pageBackgroundColor: string;
};

export function buildMobileAppColorThemeMessage(colorTheme: JungleColorTheme): MobileAppColorThemeMessage {
  return {
    typeEvent: EventSentToMobileApp.COLOR_THEME,
    colorTheme,
    pageBackgroundColor: getPageBackgroundColorForTheme(colorTheme),
  };
}

/** Tells the app the page's theme; does nothing in a browser or in an app version that keeps pages light. */
export function tellMobileAppTheColorTheme(colorTheme: JungleColorTheme): void {
  if (!doesMobileAppFollowTheColorTheme()) return;
  try {
    window.ReactNativeWebView?.postMessage(JSON.stringify(buildMobileAppColorThemeMessage(colorTheme)));
  } catch (error) {
    trackError(error, { scope: "mobile-app-color-theme", tags: { color_theme: colorTheme } });
  }
}
